import React, { useState, useEffect } from 'react';
import MobileLayout from './components/SecondSection/MobileStylistLayout.jsx';
import TabletLayout from './components/SecondSection/TabletStylistLayout.jsx';
import DesktopLayout from './components/SecondSection/DesktopStylistLayout.jsx';

import HairstylistData from '../AboutAcademy/Data/HairstylistData';

function SecondSection() {
  const [deviceType, setDeviceType] = useState('desktop');
  
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setDeviceType('mobile');
      } else if (width < 1024) {
        setDeviceType('tablet');
      } else {
        setDeviceType('desktop');
      }
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="min-h-max py-12 px-4 relative">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-12 space-y-2">
          <h2 className="text-gray-400 text-lg uppercase tracking-widest">PROFILE</h2>
          <h1 className="text-5xl font-bold uppercase bg-gradient-to-r from-blue-600 to-purple-600 text-transparent bg-clip-text">
            Our Stylist
          </h1>
        </div>

        {deviceType === 'mobile' && <MobileLayout stylists={HairstylistData} />}
        {deviceType === 'tablet' && <TabletLayout stylists={HairstylistData} />}
        {deviceType === 'desktop' && <DesktopLayout stylists={HairstylistData} />}
      </div>
    </div>
  );
}

export default SecondSection;